import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, AsyncSubject, Subject } from 'rxjs';


@Injectable()
export class LanguageService {
    private language: Subject<string> = new BehaviorSubject('en');
    private rtl: Subject<boolean> = new BehaviorSubject(false);;

    language$ = this.language.asObservable();
    rtl$ = this.rtl.asObservable();

    constructor() {

    }

    setLanguage(language: string): void {
        this.language.next(language);
        this.setRtl(language);
        localStorage.setItem('language', language);
    }

    setRtl(language: string): void {
        let rtl: boolean;
        switch (language) {
            case 'en':
                rtl = false;
                break;
            case 'he':
                rtl = true;
                break;
            default:
                rtl = false;
        }
        this.rtl.next(rtl);
    }
}
